import { retryEvent } from "@/utils/retryEvent";

export const gtagTrackEvent = (action: string, event: string, data: any) => {
  retryEvent(
    "gtag",
    () => !!window.gtag,
    () => window.gtag(action, event, data)
  );
};
